import { useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Calendar,
  BarChart3,
} from "lucide-react";
import { cn } from "@/lib/utils";

const ITEMS = [
  { to: "/", label: "Accueil", icon: LayoutDashboard, exact: true },
  { to: "/leads", label: "Leads", icon: Users },
  { to: "/calendrier", label: "Agenda", icon: Calendar },
  { to: "/rapports", label: "Rapports", icon: BarChart3 },
];

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (item) =>
    item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to);

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed inset-x-0 bottom-0 z-30 border-t border-border/60 bg-background/95 backdrop-blur-lg safe-bottom"
    >
      <ul className="grid grid-cols-4">
        {ITEMS.map((item) => {
          const Icon = item.icon;
          const active = isActive(item);
          return (
            <li key={item.to}>
              <button
                onClick={() => navigate(item.to)}
                data-testid={`bottom-nav-${item.to.replace(/\//g, "") || "home"}`}
                className={cn(
                  "flex h-[60px] w-full flex-col items-center justify-center gap-0.5",
                  active ? "text-foreground" : "text-muted-foreground"
                )}
              >
                <div
                  className={cn(
                    "flex h-7 w-12 items-center justify-center rounded-full",
                    active && "bg-accent-navy/10 dark:bg-accent-gold/15"
                  )}
                >
                  <Icon
                    className={cn("h-[18px] w-[18px]", active && "text-accent-navy dark:text-accent-gold")}
                    strokeWidth={active ? 2.5 : 2}
                  />
                </div>
                <span className={cn("text-[10px] font-medium leading-none", active && "font-semibold")}>
                  {item.label}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
